<section class="page-intro lang-page">
  <h1>{{ lang.t('selectLanguage') }}</h1>
  <div class="lang-grid">
    @for (item of choices; track item.code) {
      <button type="button" [class.on]="item.code === lang.code()" (click)="pick(item.code)">
        <img class="lang-flag" [src]="lang.flagSrc(item.flag)" alt="" width="44" height="32" />
        <span>
          <strong>{{ item.native }}</strong>
          <em>{{ item.english }}</em>
        </span>
      </button>
    }
  </div>
</section>
